import { apiFetch } from "./apiFetch";

export function fetchGoals(visionId) {
  return apiFetch(`/goals/?vision=${visionId}`);
}

export function createGoal(payload) {
  return apiFetch("/goals/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

/*
  UPDATE GOAL
*/
export function updateGoal(goalId, data) {
  return apiFetch(`/goals/${goalId}/`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

/*
  DELETE GOAL
*/
export function deleteGoal(goalId) {
  return apiFetch(`/goals/${goalId}/`, {
    method: "DELETE",
  });
}


export function createGoalProgress(data) {
  return apiFetch("/goal-progress/", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export function completeGoal(goalId, note = "") {
  return apiFetch(`/goals/${goalId}/complete/`, {
    method: "POST",
    body: JSON.stringify({ note }),
  });
}

export function undoGoalCompletion(goalId) {
  return apiFetch(`/goals/${goalId}/undo-complete/`, {
    method: "POST",
  });
}
